(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["launch-balloons"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PocketLaunchBalloons) return;
  const visitKey = 'byxtra_launch_balloons_seen_v1';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let played = false, layer = null, cleanupTimer = null;
  function claimVisit() {
    try {
      if (sessionStorage.getItem(visitKey) === '1') return false;
      sessionStorage.setItem(visitKey, '1');
      return sessionStorage.getItem(visitKey) === '1';
    } catch {
      try {
        const exists = () => document.cookie.split(';').some(cookie => cookie.trim() === visitKey + '=1');
        if (exists()) return false;
        document.cookie = visitKey + '=1; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
        return exists();
      } catch { return false; }
    }
  }
  function clear() {
    window.clearTimeout(cleanupTimer); cleanupTimer = null;
    layer?.remove(); layer = null;
  }
  function start() {
    if (played || document.hidden) return;
    const host = document.querySelector('[data-launch-balloons]');
    const template = host?.querySelector('[data-launch-balloon-template]');
    if (!template) return;
    if (motion.matches || !claimVisit()) { played = true; host.remove(); return; }
    played = true; layer = host;
    const mobile = window.matchMedia('(max-width: 600px)').matches;
    const count = mobile ? 10 : 16;
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < count; index++) {
      const balloon = template.content.firstElementChild.cloneNode(true);
      if (index % 2) balloon.classList.add('launch-balloon--gray');
      balloon.style.setProperty('--balloon-left', ((index + .5) / count * 92 + 4) + '%');
      balloon.style.setProperty('--balloon-width', (mobile ? 40 + index % 4 * 8 : 56 + index % 5 * 10) + 'px');
      balloon.style.setProperty('--balloon-duration', (3.5 + index % 5 * .14) + 's');
      balloon.style.setProperty('--balloon-delay', (index % 6 * .1) + 's');
      balloon.style.setProperty('--balloon-drift', ((index % 5 - 2) * 9) + 'px');
      fragment.append(balloon);
    }
    host.append(fragment); host.hidden = false;
    host.addEventListener('animationend', event => {
      if (event.animationName !== 'pocket-balloon-rise') return;
      event.target.remove();
      if (!host.querySelector('[data-launch-balloon]')) clear();
    });
    cleanupTimer = window.setTimeout(clear, 4800);
  }
  window.PocketLaunchBalloons = { start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); else start(); });
  window.addEventListener('pagehide', clear);
  motion.addEventListener('change', () => { if (motion.matches) clear(); });
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-photos"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PocketCardPhotos) return;
  const mobile = window.matchMedia('(max-width:600px),(hover:none) and (pointer:coarse)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bound = new Map();
  const resize = 'ResizeObserver' in window ? new ResizeObserver(entries => entries.forEach(entry => sizeImages(entry.target))) : null;
  let hintUsed = false, candidate = null, observer = null, timer = 0, frame = 0, hintTrack = null;
  function sizeImages(track) {
    const width = Math.ceil(track.clientWidth);
    if (width) track.querySelectorAll('img').forEach(img => { img.sizes = width + 'px'; });
  }
  function loadPhoto(track, index) {
    const slide = track.children[index];
    if (!slide) return null;
    const template = slide.querySelector('template[data-card-photo]');
    if (template) {
      const content = template.content.cloneNode(true), img = content.querySelector('img');
      if (img && track.clientWidth) img.sizes = Math.ceil(track.clientWidth) + 'px';
      template.replaceWith(content);
    }
    return slide.querySelector('img');
  }
  function loadNearby(track, index = Math.round(track.scrollLeft / (track.clientWidth || 1))) {
    [index - 1, index, index + 1].forEach(i => loadPhoto(track, i));
  }
  function stopHint(reset = false) {
    clearTimeout(timer); cancelAnimationFrame(frame); observer?.disconnect();
    if (hintTrack) {
      if (reset) hintTrack.scrollLeft = 0;
      hintTrack.removeAttribute('data-swipe-hint');
    }
    hintTrack = null; candidate = null; observer = null; frame = 0;
  }
  function interact() { hintUsed = true; stopHint(); }
  async function startHint(track) {
    if (hintUsed || !mobile.matches || reduced.matches || document.hidden || !track.isConnected || track.closest('[hidden]') || track.scrollLeft > 1 || track.closest('[data-quick-card]')?.querySelector('details[open]')) { stopHint(); return; }
    const width = track.clientWidth;
    if (!width) { stopHint(); return; }
    hintUsed = true; hintTrack = track; observer?.disconnect();
    const photo = loadPhoto(track, 1);
    if (photo?.decode) {
      try { await photo.decode(); } catch { if (hintTrack === track) stopHint(); return; }
    }
    if (hintTrack !== track) return;
    if (!track.isConnected || document.hidden || !mobile.matches || reduced.matches || track.closest('[hidden]')) { stopHint(); return; }
    track.setAttribute('data-swipe-hint', '');
    const start = performance.now();
    const points = [[0, 0], [.38, .5], [.50, .46], [.60, .48], [1, 0]];
    function step(now) {
      if (!track.isConnected || document.hidden || !mobile.matches || reduced.matches) { stopHint(true); return; }
      const time = Math.max(0, Math.min(1, (now - start) / 1400));
      const end = points.findIndex(point => point[0] > time);
      if (end < 0) { stopHint(true); return; }
      const a = points[end - 1], b = points[end];
      const part = (time - a[0]) / (b[0] - a[0]);
      const eased = (1 - Math.cos(Math.PI * part)) / 2;
      track.scrollLeft = width * (a[1] + (b[1] - a[1]) * eased);
      frame = requestAnimationFrame(step);
    }
    frame = requestAnimationFrame(step);
  }
  function offerHint() {
    if (hintUsed || candidate || !mobile.matches || reduced.matches || document.hidden) return;
    const track = [...document.querySelectorAll('[data-category-grid] [data-card-gallery-track]')].find(node => !node.closest('[hidden]') && node.closest('[data-category-grid]').getAttribute('aria-busy') !== 'true');
    if (!track || !('IntersectionObserver' in window)) return;
    candidate = track;
    observer = new IntersectionObserver(entries => {
      const visible = entries.find(entry => entry.target === track && entry.isIntersecting && entry.intersectionRatio >= .6);
      if (!visible) { clearTimeout(timer); return; }
      clearTimeout(timer);
      timer = setTimeout(() => startHint(track), 650);
    }, { threshold: [.6] });
    observer.observe(track);
  }
  function init(scope = document) {
    bound.forEach((abort, track) => { if (!track.isConnected) { abort.abort(); resize?.unobserve(track); bound.delete(track); } });
    scope.querySelectorAll('[data-card-gallery-track]').forEach(track => {
      if (bound.has(track)) return;
      const link = track.closest('.product-link');
      if (!link) return;
      const abort = new AbortController(), options = { passive: true, signal: abort.signal };
      bound.set(track, abort);
      track.setAttribute('data-photos-ready', '');
      sizeImages(track); resize?.observe(track);
      let gesture = null, blockClickUntil = 0;
      link.addEventListener('pointerenter', () => { if (!mobile.matches) loadPhoto(track, 1); }, options);
      link.addEventListener('focusin', () => { if (!mobile.matches) loadPhoto(track, 1); }, options);
      track.addEventListener('pointerdown', event => {
        if (!mobile.matches) return;
        interact(); blockClickUntil = 0;
        loadNearby(track);
        gesture = { x: event.clientX, y: event.clientY, left: track.scrollLeft, moved: false };
      }, options);
      track.addEventListener('pointermove', event => {
        if (gesture && Math.abs(event.clientX - gesture.x) > 8 && Math.abs(event.clientX - gesture.x) > Math.abs(event.clientY - gesture.y)) gesture.moved = true;
      }, options);
      track.addEventListener('scroll', () => {
        if (gesture && Math.abs(track.scrollLeft - gesture.left) > 6) gesture.moved = true;
        if (mobile.matches && hintTrack !== track) loadNearby(track);
      }, options);
      track.addEventListener('pointerup', () => {
        if (gesture?.moved) blockClickUntil = performance.now() + 400;
        gesture = null;
      }, options);
      track.addEventListener('pointercancel', () => {
        if (gesture) blockClickUntil = performance.now() + 400;
        gesture = null;
      }, options);
      link.addEventListener('click', event => {
        if (mobile.matches && event.detail > 0 && performance.now() < blockClickUntil) event.preventDefault();
      }, { signal: abort.signal });
      link.addEventListener('keydown', event => {
        if (!mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); interact();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const index = Math.max(0, Math.min(track.children.length - 1, Math.round(track.scrollLeft / track.clientWidth) + direction));
        loadNearby(track, index);
        track.scrollTo({ left: index * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
      }, { signal: abort.signal });
    });
    offerHint();
  }
  window.PocketCardPhotos = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('pocket:collection-updated', event => { if (!hintUsed) stopHint(); init(event.target); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (candidate && event.target.contains(candidate)) stopHint(true);
    bound.forEach((abort, track) => { if (event.target.contains(track)) { abort.abort(); resize?.unobserve(track); bound.delete(track); } });
  });
  document.addEventListener('pointerdown', event => { if (mobile.matches && event.target.closest('[data-collection-browser]')) interact(); }, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stopHint(true); else offerHint(); });
  mobile.addEventListener('change', () => { stopHint(true); if (!mobile.matches) bound.forEach((abort, track) => { track.scrollLeft = 0; }); offerHint(); });
  reduced.addEventListener('change', () => { stopHint(true); offerHint(); });
  window.addEventListener('pagehide', () => stopHint(true));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-impact"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select', event => {
  const panel = event.target.closest('[data-impact-panel]');
  if (panel) panel.open = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["route-classic"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PocketRouteClassic) return;
  let mount;
  let parking;
  let requested = false;
  function place() {
    const slots = [...document.querySelectorAll('[data-route-classic-slot]')];
    if (!slots.length) return;
    const target = slots.find(slot => slot.closest('[data-bag-drawer]')?.open) ||
      slots.find(slot => !slot.closest('[data-bag-drawer]')) || slots[0];
    if (!mount) {
      mount = document.createElement('div');
      mount.className = 'route-div';
      mount.setAttribute('desktop-align', 'left');
      mount.dataset.pocketRoute = 'classic';
    }
    if (mount.parentElement !== target) target.append(mount);
    window.PocketRouteStyle?.refresh();
  }
  function load() {
    place();
    const slot = document.querySelector('[data-route-classic-slot]');
    if (!slot || requested) return;
    requested = true;
    const installed = [...document.scripts].some(script => {
      if (!script.src) return false;
      const url = new URL(script.src, location.href);
      return (url.hostname === 'shopify-widget.route.com' && url.pathname === '/shopify.widget.js') ||
        (url.hostname === 'cdn.routeapp.io' && url.pathname.includes('/route-widget-shopify/'));
    });
    if (installed) return;
    const script = document.createElement('script');
    script.src = slot.dataset.routeScript;
    script.async = true;
    script.dataset.pocketRouteScript = 'classic';
    document.head.append(script);
  }
  ['pocket:bag-opened', 'pocket:bag-closed', 'pocket:cart-updated'].forEach(name => document.addEventListener(name, place));
  document.addEventListener('shopify:section:load', () => {
    place();
    if (document.readyState === 'complete') load();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (!mount || !event.target.contains(mount)) return;
    if (!parking) {
      parking = document.createElement('div');
      parking.hidden = true;
      document.body.append(parking);
    }
    parking.append(mount);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place, {once:true});
  else place();
  if (document.readyState === 'complete') load();
  else window.addEventListener('load', load, {once:true});
  window.PocketRouteClassic = { place };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["route-protection-style"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PocketRouteStyle) return;
  const carts = new Map();
  function update(cart) {
    const copy = cart.querySelector('[data-pocket-route-copy]');
    if (!copy) return;
    const checkout = copy.dataset.checkoutLabel;
    cart.querySelectorAll('.route-continue-without-coverage-link').forEach(button => {
      const label = checkout + ' ' + copy.dataset.withoutLabel;
      if (button.textContent !== label || !button.querySelector('.pocket-route-secondary-title')) {
        const title = document.createElement('span');
        title.className = 'pocket-route-secondary-title';
        title.textContent = label;
        button.replaceChildren(title);
      }
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    cart.querySelectorAll('[data-route-cloned-button], [data-route-copy]').forEach(button => {
      const title = button.querySelector('.route-checkout-text-stacked, .route-checkout-text');
      if (title && title.textContent !== checkout) title.textContent = checkout;
      const premium = button.querySelector('.route-premium-text-stacked, .route-premium-text');
      if (premium) {
        const label = checkout + ', ' + premium.textContent.trim();
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      }
    });
    cart.querySelectorAll('.pw-variant-preferred-checkout .pw-cashback-header-row-left > .pw-coverage-description, .pw-variant-preferred-checkout .pw-eq-title').forEach(title => {
      if (!title.querySelector('.pocket-route-heading')) title.replaceChildren(copy.content.cloneNode(true));
      const subtitle = title.parentElement.querySelector('.pw-eq-subtitle');
      if (subtitle && !subtitle.hidden) subtitle.hidden = true;
    });
  }
  function bind() {
    carts.forEach((observer, cart) => {
      if (!cart.isConnected) { observer.disconnect(); carts.delete(cart); }
    });
    document.querySelectorAll('[data-cart-checkout]').forEach(cart => {
      if (!carts.has(cart)) {
        let queued = false;
        const observer = new MutationObserver(() => {
          if (queued) return;
          queued = true;
          queueMicrotask(() => { queued = false; if (cart.isConnected) update(cart); });
        });
        observer.observe(cart, { childList: true, subtree: true, characterData: true });
        carts.set(cart, observer);
      }
      update(cart);
    });
  }
  ['pocket:bag-opened', 'pocket:cart-updated', 'shopify:section:load'].forEach(name => document.addEventListener(name, bind));
  document.addEventListener('shopify:section:unload', event => {
    carts.forEach((observer, cart) => {
      if (event.target.contains(cart)) { observer.disconnect(); carts.delete(cart); }
    });
  });
  window.PocketRouteStyle = { refresh: bind };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
  } catch(e) { console.error(e); }
})();

})();
